module.exports = __webpack_public_path__ + "img/11_of_Clubs.svg.e28a796d.png";